export const getCurrentLevel = (ranking, clientRanking) => {
  const levels = [1, 2, 3];
  let level = 0;

  levels.forEach(l => {
    if (clientRanking && ranking >= clientRanking[`level${l}Points`]) {
      level++;
    }
  });

  return level;
};
